import React from 'react'
import { Link } from 'react-router-dom'

function Payments() {
  return (
    <div>
        <div className="breadcrumb-row">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                            <div className="breadcrumb-title-heading">
                                <h1 className="title">Payment</h1>
                            </div>
                            <div className="breadcrumb-wrapper">
                                <span className="mr-1"><i className="ti ti-home"></i></span>
                                <Link title="Homepage" to="/">Home</Link>
                                <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                                <span className="ttm-textcolor-skincolor">Payment</span>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>                    
        </div>
        {/* <!-- Section Start --> */}
    <section className="section">
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="payment_box">
                        <h5 className="title">Amount</h5>
                        <ul className="address_list">
                            <li>
                                <div className="custom-control custom-radio mr-sm-2">
                                    <input type="radio" className="custom-control-input" name="customamount" id="amountone"/>
                                    <label className="custom-control-label" htmlFor="amountone">
                                        <span className="top">
                                            <span className="fw-500 thm-color-two">Enter Amount</span>
                                        </span>
                                    </label>
                                </div>
                                <div className="payment_value">
                                    <div className="input-group">
                                        <span className="input-group-text">$</span>
                                        <input type="text" name="#" placeholder="0.00" autoComplete="off"/>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="custom-control custom-radio mr-sm-2">
                                    <input type="radio" className="custom-control-input" name="customamount" id="amounttwo"/>
                                    <label className="custom-control-label" htmlFor="amounttwo">
                                        <span className="top">
                                            <span className="fw-500 thm-color-two">Enter Amount</span>
                                        </span>
                                    </label>
                                </div>
                                <div className="payment_value">$435.00</div>
                            </li>
                        </ul>
                    </div>
                    <div className="payment_box">
                        <h5 className="title">Payment Method</h5>
                        <ul className="address_list">
                            <li>
                                <div className="custom-control custom-radio mr-sm-2">
                                    <input type="radio" className="custom-control-input" name="paymentmethod" id="methodone"/>
                                    <label className="custom-control-label" htmlFor="methodone">
                                        <span className="top">
                                            <span className="fw-500 thm-color-two">Ending in: ...4512</span>
                                        </span>
                                        <span className="mb-0 p">Last time used: Thu, Mar 15, 2021</span>
                                    </label>
                                </div>
                                <div className="payment_icon">
                                    <img src="/tm/react/toolways/assets/images/icon/visa.png" className="image-fit-contain" alt="img"/>
                                </div>
                            </li>
                            <li>
                                <div className="custom-control custom-radio mr-sm-2">
                                    <input type="radio" className="custom-control-input" name="paymentmethod" id="methodtwo"/>
                                    <label className="custom-control-label" htmlFor="methodtwo">
                                        <span className="top">
                                            <span className="fw-500 thm-color-two">Ending in: ...5513</span>
                                        </span>
                                        <span className="mb-0 p">Never Used</span>
                                    </label>
                                </div>
                                <div className="payment_icon">
                                    <img src="/tm/react/toolways/assets/images/icon/master.png" className="image-fit-contain" alt="img"/>
                                </div>
                            </li>
                            <li>
                                <button type="button" className="thm-btn btn-rectangle btn-border lh-normal">Add New Card</button>
                            </li>
                        </ul>
                    </div>
                    <Link to="/thankyou" className="thm-btn btn-rectangle thm-bg-color-one w-100">Pay Now</Link>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Payments